<div class="grid grid-section grid-section-large">
  <div class="footer-top">
    <div class="social-networks">
      <logo></logo>
      <social-networks></social-networks>
    </div>
    <div class="footer-map">
      <svg width="103" height="114" viewBox="0 0 103 114" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3973_12963)">
          <path d="M57.2771 0.0927734C56.5929 0.0927734 50.6067 1.17682 50.6067 1.17682C50.3287 10.0387 44.1073 17.8911 31.3009 19.2542L28.5643 14.3408L23.1981 14.869L25.6139 27.6667L1.28613 26.6231L3.89444 35.4616C30.1037 43.8742 28.9064 67.9404 23.1981 89.4509C33.2465 100.739 53.5143 99.6312 62.9641 98.6302C63.6268 85.3831 74.167 84.8932 92.0189 91.7724C94.4348 88.024 96.0383 84.1052 101.554 80.9745L91.5913 51.2644L85.7119 52.5849C88.0637 48.0911 92.5961 41.9574 96.4872 39.0822L99.8224 20.5746C80.8801 19.2329 68.5227 10.7011 57.2771 0.0927734Z"/>
          <path d="M99.3453 94.3659L97.8681 93.6689C93.8203 95.0422 92.4209 97.1694 91.2236 99.3585L93.0532 101.062L91.3014 101.104L91.6901 102.844L93.4419 103.267L92.312 106.174L94.0224 106.055L93.0532 108.611L95.5773 109.266L94.1416 110.857L99.1898 113.877C101.294 110.056 101.683 106.236 102.533 102.415C102.528 99.7974 102.569 97.1642 101.253 94.9441C101.745 93.1298 101.823 91.2391 101.175 89.2173L99.5422 89.5271C99.3194 91.1405 99.0654 92.754 99.3453 94.3659Z"/>
          <path class="var" fill-rule="evenodd" clip-rule="evenodd" d="M97.1915 84.3076C95.6834 82.7509 93.5671 81.7827 91.2239 81.7827C87.0736 81.7827 83.6354 84.8199 83.0269 88.7847C85.7725 89.5158 88.7749 90.5225 92.0188 91.7725C92.4357 91.1256 92.8285 90.4736 93.2213 89.8215C94.3513 87.9456 95.482 86.0686 97.1915 84.3076Z"/>
        </g>
        <defs>
          <clipPath id="clip0_3973_12963">
            <rect width="102" height="114" fill="white" transform="translate(0.833496)"/>
          </clipPath>
        </defs>
      </svg>

    </div>
    <div *ngFor="let chunk of navigation" class="navigation">
      <a *ngFor="let navItem of chunk" [routerLink]="navItem.url">{{navItem.title}}</a>
    </div>
  </div>
</div>
<div class="footer-bottom">
  <div class="grid grid-section">
    <div class="footer-partners">
      <div class="partner" *ngFor="let partner of partners">
        <media-attachment [width]="partner.sizes?.['medium-width']" [height]="partner.sizes?.['medium-height']" [optimized]="false" [fill]="false" class="partner-image" [url]="partner.sizes?.medium"></media-attachment>
        <div class="caption" *ngIf="partner.caption">{{partner.caption}}</div>
      </div>
    </div>
  </div>

</div>
<div class="footer-others-partners">
  <div class="grid md-grid-cols-2 gap-m">
    <div class="footer-partners">
      <div class="partner" *ngFor="let partner of othersPartners">
        <media-attachment [width]="partner.sizes?.['medium-width']" [height]="partner.sizes?.['medium-height']" [optimized]="false" [fill]="false" class="partner-image" [url]="partner.sizes?.medium"></media-attachment>
      </div>
    </div>
    <div class="footer-partners footer-partners-carousel">
      <swiper
        #partnersSlider
        [config]="partnersSliderConfig"
      >
        <ng-template swiperSlide *ngFor="let partner of othersPartnersCarroussel; let i = index">
          <div class="partner" >
            <media-attachment [width]="partner.sizes?.['medium-width']" [height]="partner.sizes?.['medium-height']" [optimized]="false" [fill]="false" class="partner-image" [url]="partner.sizes?.medium"></media-attachment>
          </div>
        </ng-template>
      </swiper>

    </div>
  </div>
</div>
